import React, { Component } from "react";
import Slider from "react-slick";
import { Container } from "reactstrap";
import { FormattedMessage } from "react-intl";
import BlogPageCard from "../BlogPage/BlogPageCard";
import Picture from '../../Picture'
import { handlePublicRequestError, Request } from '../../../helpers/request'
import LocaleLink from '../../Routes/LocaleLink'


class HomepageGallery extends Component
{
    state = {
        articles: null
    };

    componentDidMount() {
        let pagination = 8;

        window.innerWidth < 450 ? pagination = 4 : null;

        Request.get('articles?pagination=' + pagination)
            .then((articles) => this.setState({ articles: articles.data }))
            .catch(handlePublicRequestError);
    }

    settings = {
        dots: true,
        lazyLoad: true,
        infinite: false,
        arrows: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        adaptiveHeight: false,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    adaptiveHeight: false
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    adaptiveHeight: true
                },
            },
        ]
    };

    breakpointColumnsObj = {
        default: 4,
        992: 2,
        768: 1,
    };

    isSliderOn = () => {
        return window.innerWidth <= 992
    }

    render() {

        if (!this.state.articles || this.state.articles.length === 0) return null;

        return(
            <section className="section-blog">
                <Container>
                    <div className={`blog-text-wrapper ${this.isSliderOn()?' blog-text-wrapper-slider':''}`}>
                        <div className="blog-title">
                            <Picture
                                src={require("../../../../images/blog.png")}
                                webp={require("../../../../images/blog.webp")} />

                            <div className="default-text gallery-text">
                                <h2>
                                    <FormattedMessage
                                        id="portfolio.homepage.gallery.title"
                                        defaultMessage="Toute l’actualité du digital"
                                    />
                                </h2>
                                <p className="default-text-subtitle gallery-text-subtitle">
                                    <FormattedMessage
                                        id="portfolio.homepage.gallery.subtitle"
                                        defaultMessage="Notre blog regroupe les ressources nécessaires pour vous permettre de vous aider dans vos recherches, vos entretiens ou pour vous tenir informés de l’actualité de l’écosystème du numérique."
                                    />
                                </p>
                                <p className="default-text-paragraph gallery-text-paragraph">
                                    <FormattedMessage
                                        id="portfolio.homepage.gallery.paragraph_1"
                                        defaultMessage="Nos articles sont rédigés en collaboration avec des experts et abordent des sujets qui pourront toucher candidats et recruteurs."
                                    />
                                </p>
                                <p className="default-text-paragraph gallery-text-paragraph">
                                    <FormattedMessage
                                        id="portfolio.homepage.gallery.paragraph_2"
                                        defaultMessage="Retrouvez également chaque année des études de salaires sur les métiers de la tech, du marketing et commercial."
                                    />
                                </p>
                            </div>

                            <div>
                                <LocaleLink to="/blog" className="btn btn-line-warning">
                                    <FormattedMessage
                                        id="portfolio.homepage.gallery.see_more"
                                        defaultMessage="Voir nos articles"
                                    />
                                </LocaleLink>
                            </div>
                        </div>
                    </div>
                    <div className="gallery">
                        {window.innerWidth > 992
                        ?
                            this.renderGallery()

                        :
                            this.renderGallerySlider()
                        }
                    </div>
                </Container>
            </section>
        )
    }


    renderGallerySlider() {

        const { articles } = this.state;

        return(
            <Slider className="gallery-wrap gallery" {...this.settings}>
                {
                    articles.map((card, key) => {
                        return (
                            <BlogPageCard
                                data={card}
                                key={key}
                            />
                        )
                    })}
            </Slider>
        )
    }

    renderGallery() {
        const { articles } = this.state;

        return(
            <div className={'blog-list'}>
                <div className="first_column">
                    <div />
                    {
                        articles
                            .slice(0,1)
                            .map((card, key) => {
                                return (
                                    <div key={key}>
                                        <BlogPageCard
                                            data={card}
                                            key={key}
                                        />
                                    </div>
                                )
                        })
                    }
                </div>
                <div className="second_column">
                    <div />
                    {
                        articles
                            .slice(1,2)
                            .map((card, key) => {
                                return (
                                    <div key={key}>
                                        <BlogPageCard
                                            data={card}
                                            key={key}
                                        />
                                    </div>
                                )
                            })
                    }
                </div>
                <div className="third_column">
                    {
                        articles
                            .slice(2,5)
                            .map((card, key) => {
                                return (
                                    <div key={key}>
                                        <BlogPageCard
                                            data={card}
                                            key={key}
                                        />
                                    </div>
                                )
                            })
                    }
                </div>
                <div className="fourth_column">
                    {
                        articles
                            .slice(5)
                            .map((card, key) => {
                                return (
                                    <div key={key}>
                                        <BlogPageCard
                                            data={card}
                                            key={key}
                                        />
                                    </div>
                                )
                            })
                    }
                </div>
            </div>
        )
    }
}

export default HomepageGallery;
